import { gql } from "@apollo/client"

export const IS_ENTERPRISE_NAME_UNIQUE = gql`
  query IsEnterpriseNameUnique($enterprise_name: String!, $enterprise_id: ID) {
    isEnterpriseNameUnique(
      enterprise_name: $enterprise_name
      enterprise_id: $enterprise_id
    )
  }
`
export const IS_ORGANIZATION_NAME_UNIQUE = gql`
  query IsUniqueOrganization(
    $organization_name: String!
    $enterprise_id: ID!
    $organization_id: ID
  ) {
    isUniqueOrganization(
      organization_name: $organization_name
      enterprise_id: $enterprise_id
      organization_id: $organization_id
    )
  }
`

export const IS_PROGRAM_ID_NAME_UNIQUE = gql`
  query IsProgramIdNameUnique(
    $program_id_name: String!
    $enterprise_id: ID!
    $organization_id: ID
    $program_identity_id: ID
  ) {
    isUniqueProgramIdName(
      program_id_name: $program_id_name
      enterprise_id: $enterprise_id
      organization_id: $organization_id
      program_identity_id: $program_identity_id
    )
  }
`
